export default __webpack_public_path__ + "static/media/cloudcayr.2e168c81.png";